module.exports = __webpack_public_path__ + "static/img/wechat.932be83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobiigw/wechat.png
// module id = reMx
// module chunks = 1